import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4a0db90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-BG" }
const _hoisted_2 = { class: "home" }
const _hoisted_3 = { class: "api-grid" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "api-usage-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Tokens")
  ])
], -1))
const _hoisted_5 = {
  key: 0,
  class: "api-key"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Label", -1))
const _hoisted_7 = {
  key: 1,
  class: "api-key"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "API Key", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "You can only copy your key once.", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "tokens-table" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "tokens-header" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "label" }, "Label"),
    /*#__PURE__*/_createElementVNode("th", null, "Created"),
    /*#__PURE__*/_createElementVNode("th", null, "Expires"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_14 = {
  key: 0,
  class: "example-token"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "api-key-label" }, "Macbook Pro", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "api-key-date" }, " a few seconds ago ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "api-key-date" }, "in 12 months", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("button", { class: "button button-small" }, " Revoke ")
], -1))
const _hoisted_19 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "example-token"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "api-key-label" }, "Discord Bot", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "api-key-date" }, "1 day ago", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "api-key-date" }, "in 12 months", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("button", { class: "button button-small" }, " Revoke ")
], -1))
const _hoisted_25 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "api-key-label" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "api-key-date" }
const _hoisted_29 = { class: "api-key-date" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 2,
  class: "api-key-limit"
}
const _hoisted_32 = {
  key: 3,
  class: "api-key-limit"
}
const _hoisted_33 = {
  key: 4,
  class: "api-key-limit"
}
const _hoisted_34 = {
  key: 0,
  class: "api-usage"
}
const _hoisted_35 = { class: "api-usage-header" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("b", null, "API Usage")
], -1))
const _hoisted_37 = {
  key: 0,
  class: "api-usage-chart"
}
const _hoisted_38 = { id: "usage-section" }
const _hoisted_39 = { class: "api-menu" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Get to Know Prodia", -1))
const _hoisted_41 = { class: "api-menu-list" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://docs.prodia.com/getting-started/",
  target: "_blank"
}, "Getting Started", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://docs.prodia.com/reference/pricing",
  target: "_blank"
}, "Pricing", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://billing.stripe.com/p/login/8wMaGm6bRgYC6xWfYY",
  target: "_blank"
}, "Manage Subscription", -1))
const _hoisted_45 = { class: "view-docs-container" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "view-docs-header" }, "Looking for more?", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button view-docs-button" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "button view-docs-button",
    href: "https://docs.prodia.com",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("p", null, "View the Docs")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_icon = _resolveComponent("copy-icon")!
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_chevronIcon = _resolveComponent("chevronIcon")!
  const _component_Receipt = _resolveComponent("Receipt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("section", {
          class: _normalizeClass({
						'api-usage': true,
						'v2-keys': true,
						unpaid: _ctx.isFree
					})
        }, [
          _hoisted_4,
          (_ctx.newV2Token === undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "api-input",
                  placeholder: "Sally's Macbook",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v2TokenLabel) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.v2TokenLabel]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createNewV2Token && _ctx.createNewV2Token(...args))),
                  class: "create-v2-key-button"
                }, " Create API Key ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("input", {
                  type: "text",
                  disabled: "",
                  value: _ctx.newV2Token,
                  class: "api-input"
                }, null, 8, _hoisted_9),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyNewV2Token && _ctx.copyNewV2Token(...args))),
                  class: "copy-button"
                }, [
                  _createVNode(_component_copy_icon, { class: "copy-icon" })
                ])
              ])),
          _createElementVNode("p", {
            style: _normalizeStyle({
							visibility: _ctx.newV2Token ? 'visible' : 'hidden'
						})
          }, _hoisted_11, 4),
          _createElementVNode("p", {
            style: _normalizeStyle({
							visibility:
								!_ctx.newV2Token && _ctx.v2TokenError !== undefined
									? 'visible'
									: 'hidden'
						})
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.v2TokenError), 1)
          ], 4),
          _createElementVNode("div", null, [
            _createElementVNode("table", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("tbody", {
                class: _normalizeClass({
									tokens: true,
									loading: _ctx.isLoading
								})
              }, [
                (!_ctx.isPaid || _ctx.v2Tokens === undefined)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _hoisted_19))
                  : _createCommentVNode("", true),
                (!_ctx.isPaid || _ctx.v2Tokens === undefined)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, _hoisted_25))
                  : _createCommentVNode("", true),
                (
										_ctx.sortedTokens && _ctx.sortedTokens.length > 0
									)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.sortedTokens, (key, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: _normalizeClass({
										'explorer-token':
											_ctx.isExplorerToken(key) ||
											key.revoked_at !== null
									})
                      }, [
                        _createElementVNode("td", _hoisted_26, [
                          _createTextVNode(_toDisplayString(key.data?.label) + " ", 1),
                          (key.revoked_at !== null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "(revoked)"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.getRelativeDate(key.created_at)), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.getRelativeDate(key.expires_at)), 1),
                        _createElementVNode("td", null, [
                          (
												key.revoked_at === null &&
												!_ctx.isExplorerToken(key)
											)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "button button-small",
                                onClick: ($event: any) => (_ctx.revokeV2Token(key))
                              }, " Revoke ", 8, _hoisted_30))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_31, "Loading..."))
            : (_ctx.isFree)
              ? (_openBlock(), _createElementBlock("p", _hoisted_32, " You must upgrade to create tokens. "))
              : (_openBlock(), _createElementBlock("p", _hoisted_33, " You can create up to 5 active tokens. "))
        ], 2),
        (_ctx.usage)
          ? (_openBlock(), _createElementBlock("section", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                (_ctx.usageChart)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.downloadCSV && _ctx.downloadCSV(...args))),
                      class: "button button-small"
                    }, [
                      _createVNode(_component_DownloadIcon, { style: {"width":"16px","height":"16px","margin-right":"8px"} }),
                      _createTextVNode(" Download CSV ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.plan)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("section", _hoisted_38, [
                      _createVNode(_component_bar_chart, {
                        data: _ctx.usageChart,
                        options: {
									responsive: true,
									scales: {
										x: {
											stacked: true
										},
										y: {
											stacked: true
										}
									}
								}
                      }, null, 8, ["data"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("ul", _hoisted_41, [
          _createElementVNode("li", null, [
            _hoisted_42,
            _createVNode(_component_chevronIcon)
          ]),
          _createElementVNode("li", null, [
            _hoisted_43,
            _createVNode(_component_chevronIcon)
          ]),
          _createElementVNode("li", null, [
            _hoisted_44,
            _createVNode(_component_chevronIcon)
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _hoisted_47,
          _createVNode(_component_Receipt, { class: "receipt-icon" })
        ])
      ])
    ])
  ]))
}